<template>
	<div>
		<div class="form-group" :class="className">
			<label class="form-label" v-show="label">{{ label }}</label>
			<div class="radio-group" :id="'form-radiogroup-' + field.adPropertyKey">
				<div v-for="(option, i) in options" :key="option" class="">
					<div
						class="form-check"
						:class="{
							active: option.adPropertyValue === activeFilter,
						}"
					>
						<template v-if="i === 0 && showAll">
							<input
								v-model="model"
								type="radio"
								class="form-check-input"
								:name="'form-radio-' + field.adPropertyKey"
								:id="'form-radio-' + field.adPropertyKey + '-default'"
								:value="option.adPropertyValue"
							/>
							<label
								class="form-check-label"
								:for="'form-radio-' + field.adPropertyKey + '-default'"
							>
								Alle
							</label>
						</template>
						<template v-if="option.adPropertyValue === activeFilter">
							<input
								v-model="model"
								class="form-check-input checked"
								type="radio"
								@click="uncheckRadio(option.adPropertyValue)"
								:name="'form-radio-' + field.adPropertyKey"
								:id="
									'form-radio-' +
									field.adPropertyKey +
									'-' +
									option.adPropertyValue.toLowerCase()
								"
								:value="option.adPropertyValue"
								checked
							/>
							<label
								class="form-check-label"
								:for="
									'form-radio-' +
									field.adPropertyKey +
									'-' +
									option.adPropertyValue.toLowerCase()
								"
							>
								{{ refData[option.adPropertyValue] }}
								<template v-if="option.count > 0">
									({{ option.count }})</template
								>
							</label>
						</template>
						<template v-else>
							<input
								v-model="model"
								class="form-check-input"
								type="radio"
								@change="updateFilter()"
								:name="'form-radio-' + field.adPropertyKey"
								:id="
									'form-radio-' +
									field.adPropertyKey +
									'-' +
									option.adPropertyValue.toLowerCase()
								"
								:value="option.adPropertyValue"
							/>
							<label
								class="form-check-label"
								:for="
									'form-radio-' +
									field.adPropertyKey +
									'-' +
									option.adPropertyValue.toLowerCase()
								"
							>
								{{ refData[option.adPropertyValue] }}
								<template v-if="option.count > 0">
									({{ option.count }})</template
								>
							</label>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormRadio',
	data() {
		return {
			selected: '',
			isChecked: true,
			model: '',
		}
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		className: {
			type: String,
			required: false,
			default: '',
		},
		showLabel: {
			type: Boolean,
			required: false,
			default: true,
		},
		field: {
			type: Object,
			required: true,
		},
		refData: {
			type: Object,
			required: true,
		},
		showAll: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	computed: {
		options() {
			let hits = this.field.hits
			return hits.sort((a, b) =>
				a.adPropertyValue.toLowerCase() > b.adPropertyValue.toLowerCase()
					? 1
					: -1
			)
		},
		activeFilter() {
			if (store.state.filterItems[this.field.adPropertyKey]) {
				return store.state.filterItems[this.field.adPropertyKey].adPropertyValue
			} else {
				return false
			}
		},
	},
	methods: {
		uncheckRadio(selected) {
			if (selected === this.model) {
				this.model = ''
				this.$store.commit('deleteFilter', this.field.adPropertyKey)
				this.$emit('updateFilter', this.model)
			}
		},
		updateFilter() {
			if (this.model !== '') {
				const filterItem = {
					adPropertyKey: this.field.adPropertyKey,
					adPropertyValue: this.model,
					adPropertyType: this.field.adPropertyType,
				}
				this.$store.commit('updateFilter', filterItem)
			} else {
				this.$store.commit('deleteFilter', this.field.adPropertyKey)
			}
			this.$emit('updateFilter', this.model)
		},
	},
	created() {
		if (store.state.filterItems[this.field.adPropertyKey]) {
			this.model =
				store.state.filterItems[this.field.adPropertyKey].adPropertyValue
		}
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (
					state.filterItems[this.field.adPropertyKey] === undefined &&
					this.model !== ''
				) {
					this.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>

<style lang="scss">
.radio-group {
	.form-check {
		&.active {
			.form-check-label {
				color: $primary;
			}
		}
	}
}
</style>
